import React from 'react';

import * as S from './Filters.styles';

import {ArrayTogglerBehaviorTypes} from '../../../../hooks/useArrayToggler';

import CheckBoxList from '../../../../../stories/components/hotels/common/CheckBoxList/CheckBoxList';

const HotelTypeFilter = ({updateFilter, hotelTypeFiltersList, hotelTypeFilter}) => {
  const onFilterSelect = (item, itemUnderAction, isSelected) => {
    updateFilter({type: item});
  };

  return (
    <CheckBoxList
      name="HOTEL TYPE"
      data={hotelTypeFiltersList}
      lookup={item => item}
      type={ArrayTogglerBehaviorTypes.multiSelect}
      renderItem={item => <S.TextTruncatorSpan>{item}</S.TextTruncatorSpan>}
      actionHandler={onFilterSelect}
      defaultState={hotelTypeFilter || []}
      resetHandlerProp={() => {
        updateFilter({type: []});
      }}
      maxLength={3}
    />
  );
};

export default React.memo(HotelTypeFilter);
